// Gutters should appear first and last in the Sub-Nav to give it some separation from the edge of the browser window.
export default function GutterDirective() {
  return {
    restrict: 'E'
  };
}
